import { Grid } from "@mui/material";
import moment from "moment";
import { useMemo } from "react";
import { Calendar, momentLocalizer, Views } from "react-big-calendar";
import { EventObject } from "../../redux/Hire/candidateMeetingApi";
import CustomWeekView from "../HireV3/TimeslotBooking/CustomWeekView";
import Day from "../HireV3/TimeslotBooking/components/Day";
import Timeslot from "../HireV3/TimeslotBooking/components/Timeslot";
import TimeslotGutterText from "../HireV3/TimeslotBooking/components/TimeslotGutterText";
import InterviewEvent from "./InterviewEvent";
import InterviewZone from "./InterviewZone";

const localizer = momentLocalizer(moment);

const COLORS = [
  "#F1CFFF",
  "#F0E9FC",
  "#FFCEAF",
  "#DFFEAF",
  "#CFD0FF",
  "#FFB6B6",
  "#CFF4FC",
  "#D1F2A5",
  "#F9E79F",
  "#F5B7B1",
];

type Props = {
  filteredData: Array<EventObject>;
  startDate: moment.Moment;
};

const InterviewCalendar = ({ filteredData, startDate }: Props) => {
  const memoizedInterviews = useMemo(() => {
    if (!filteredData) return [];
    const cachedColor = {};
    return filteredData.map((interview) => ({
      id: interview.id.toString(),
      title: `${interview.candidateName}`,
      start: moment.utc(interview.meetingStartedOn).local().toDate(),
      end: moment.utc(interview.meetingEndedOn).local().toDate(),
      isAvailable: true,
      color: cachedColor[interview.interviewerEmail]
        ? cachedColor[interview.interviewerEmail]
        : (cachedColor[interview.interviewerEmail] =
            COLORS[Math.floor(Math.random() * COLORS.length)]),
      jobId: interview.jobId,
      candidateEmail: interview.candidateEmail,
    }));
  }, [filteredData]);

  const { scrollToTime, views, components } = useMemo(
    () => ({
      scrollToTime: new Date(1972, 0, 1, 6, 45, 0, 0),
      views: {
        week: CustomWeekView,
      },
      components: {
        // dateCellWrapper: Day,
        timeSlotWrapper: Timeslot,
        timeGutterHeader: TimeslotGutterText,
        timeGutterWrapper: InterviewZone,
        week: {
          header: Day,
          event: InterviewEvent,
        },
      },
    }),
    [],
  );

  return (
    <Grid height={"calc(100vh - 150px)"}>
      <Calendar
        className="interview-calendar"
        date={startDate.toDate()}
        defaultView={Views.WEEK}
        events={memoizedInterviews}
        localizer={localizer}
        scrollToTime={scrollToTime}
        showMultiDayTimes={true}
        selectable={false}
        step={15}
        timeslots={4}
        enableAutoScroll
        toolbar={false}
        views={views}
        components={components}
      />
    </Grid>
  );
};

export default InterviewCalendar;
